// @flow

import { CLEAR_ERROR_MESSAGE, SET_ERROR_MESSAGE } from '../constants/action_types'

export type ErrorType = {
    message?: string,
}

type ErrorActionType = {
    ...ErrorType,
    type: string,
}

const initialState = {
    message: undefined,
}

export default function error(state: ErrorType = initialState, action: ErrorActionType) {
    let ret = state
    if (action.type === CLEAR_ERROR_MESSAGE) {
        ret = {
            ...state,
            message: undefined,
        }
    } else if (action.type === SET_ERROR_MESSAGE) {
        ret = {
            ...state,
            message: action.message,
        }
    }
    return ret
}
